import { Button, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import * as ROUTES from "../../constants/routes";
import { useHistory } from "react-router-dom";

const notFoundAnimation = require("../../assets/conecction_error.json");

const ErrorPage = ({ reset }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  const goToHome = () => {
    typeof reset !== "function" ? history.push(ROUTES.HOME) : reset();
  };

  return (
    <Grid container justify="space-around" className={styles.errorContainer}>
      <Grid item xs={12} md={5} container justify="center" className={styles.iconContainer}>
        <Lottie animationData={notFoundAnimation} style={{ width: "80%" }} loop={true} />
      </Grid>

      <Grid item xs={12} md={5} container>
        <Container>
          <Grid item xs={12} container justify="center">
            <Typography variant="h3" className={styles.errorTitle}>
              {t("se_ha_producido_un_error")}
            </Typography>
            <Typography variant="h6" className={styles.errorSubtitle}>
              {t("reanibex_Training_no_ha_cargado_correctamente,_vuelve_a_la_página_principal._Si_el_problema_persiste_póngase_en_contacto_con_en_el_administrador")}
            </Typography>
            <Button variant="outlined" onClick={goToHome} style={{ textTransform: "none" }}>
              {t("pagina_principal")}
            </Button>
          </Grid>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;

const useStyles = makeStyles((theme) => ({
  errorContainer: {
    position: "absolute",
    zIndex: 1200,
    top: 0,
    minHeight: "100vh",
    backgroundColor: "#fff1ff",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
    },
  },
  errorTitle: {
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      font: "400 40px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
    },
    [theme.breakpoints.down("sm")]: {
      font: "400 30px/40px Google Sans,Arial,sans-serif",
    },
  },
  iconContainer: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "-2vh",
      marginBottom: "-20vh",
    },
  },
  errorSubtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 16px/26px Google Sans,Arial,sans-serif",
    marginTop: 16,
    marginBottom: 32,
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "95%",
    },
  },
}));
